import React, { Component } from 'react';
import Icon from '../Common/Icon';
import { connect } from 'react-redux';
import purifyHTML from '../../utils/purifyHTML';
import { getIsRequiredFlexLoading } from '../../utils/flexRules';


class ReisadviezenFlex extends Component {
    render() {

        const { loading, information, config } = this.props;
        const { title, available, moreInfoUrl, 
            moreInfo, moreInfoScreenReaderPostFix, 
            reservationButton, reservationButtonScreenReaderPostFix 
        } = config || {};

        const cleanTitle = purifyHTML(title);
        const cleanAvailableText = purifyHTML(available);

        return !loading && information && information.tripAvailable ? (
            <div className="theme--accent theme--accent-dark">
                <div className="container reisadvies-flex__wrapper">
                    <div className="container--margin container--center">
                        <h3 dangerouslySetInnerHTML={cleanTitle} />
                        <div className="reisadvies-flex">
                            <p className="reisadvies-flex__description" dangerouslySetInnerHTML={cleanAvailableText} />
                            <div className="reisadvies-flex__buttons">
                                <a
                                    href={moreInfoUrl}
                                    className="link link--animation-on-hover reisadvies-flex__more-info"
                                >
                                    {moreInfo} <span className="sr-only">{moreInfoScreenReaderPostFix}</span>
                                    <Icon className="btn__icon btn__icon--right" iconName="arrow-right" />
                                </a>
                                <a href={information.orderUrl} className="btn reisadvies-flex__reservation">
                                    {reservationButton} <span className="sr-only">{reservationButtonScreenReaderPostFix}</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        ) : null;
    }
}

export default connect((state, props) => {
    const flex = state.reisadviezen.flex[props.config.flexType] || {};
    return {
        information: flex.information,
        loading: state.reisadviezen.loading || flex.loading || getIsRequiredFlexLoading(state)
    };
})(ReisadviezenFlex);



// WEBPACK FOOTER //
// ./src/components/Reisadviezen/Flex.js